import React, { Fragment } from 'react';
import { NavLink } from "react-router-dom";
import { ProductGrid } from "../StoreSales/Blocks/ProductGrid";
import CheckBoxTicked from "../../../../../assets/images/CheckBoxTicked.png";
import AddButon from "../../../../../assets/images/AddButon.png";
import SubtractButton from "../../../../../assets/images/SubtractButton.png";
import CheckBoxTickedSelected from "../../../../../assets/images/CheckBoxTickedSelected.png";
import AddButonSelected from "../../../../../assets/images/AddButonSelected.png";
import SubtractButtonSelected from "../../../../../assets/images/SubtractButtonSelected.png";
import CheckBoxTickedError from "../../../../../assets/images/CheckBoxTickedError.png";
import AddButonError from "../../../../../assets/images/AddButonError.png";
import SubtractButtonError from "../../../../../assets/images/SubtractButtonError.png";
import { Image } from "antd";
import { getUploadedFile } from "../../../../../helpers/utilities";
import { TextField } from "@mui/material";


export default function GridViewNew(props) {
    const { loadMore, loadMoreContent, loadMoreTask, details, classes, errorLineForm, showNameDesc,
        clsx, selected, handleQuantityChange, handleGridClick, salesType, type,
        changeHandlerLine, form, stockLoading
    } = props;

    const gridView = (data, dataPro) => {
        return (
            <div className={clsx(classes.gridColoum, classes.prod_grp_tit, { [classes.disabled]: stockLoading })}>
                <div className={clsx(classes.gridColoumInner, { [classes.gridColoumYellow]: selected?.length > 0 && selected?.find(el => el?.productId === data?.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")) }, { [classes.gridColoumGreen]: form?.productId === data?.id }, { [classes.gridColoumRed]: errorLineForm?.productId === data?.id && (data?.parentLineNumber == null || data?.parentLineNumber === "") })}>
                    <NavLink to={"#"} data-productname={data?.productName} className={clsx(classes.gridColoumInnerClick, { [classes.gridColoumError]: errorLineForm?.productId === data?.id }, { [classes.gridColoumInnerHover]: data?.imageUri })} onClick={() => handleGridClick(data, dataPro)}>
                        <div className={clsx(classes.gridColoumInnerPadd)}>
                            <div className={classes.gridColoumInnerBox}>
                                {
                                    !data?.imageUri ? (
                                        <div style={{ width: "100%" }}>{showNameDesc === 'name' ? data?.productName : (data?.description || '---')}</div>
                                    ) : (
                                        <>
                                            <div className={clsx(classes.grpproductName)}>{showNameDesc === 'name' ? data?.productName : (data?.description || '')}</div>
                                            <div className={clsx(classes.grpproductimage)}>
                                                <img alt={data?.productName} className={clsx(classes.grpproductimg)} src={getUploadedFile(data?.imageUri)} />
                                            </div>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </NavLink>
                    {
                        selected?.length > 0 && selected?.find(el => el?.productId === data?.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")) && <><Image
                            src={errorLineForm.productId === data.id ? CheckBoxTickedError : form?.productId === data?.id ? CheckBoxTickedSelected : CheckBoxTicked}
                            preview={false}
                            rootClassName={clsx(classes.gridColoumCheckBox)}
                        /> <div className={classes.gridColoumQuantity}>
                                <TextField autoComplete='one-time-code'
                                    type={'number'}
                                    className={classes.blod}
                                    onChange={(e) => {
                                        if (e.target.value !== '') {
                                            if (salesType === 'Sales' && e.target.value < 0) {
                                                changeHandlerLine(selected?.find(el => el?.productId === data.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")), e.target.value = 0, 'quantity');
                                            } else if (salesType === 'Sale Return' && e.target.value >= 0) {
                                                changeHandlerLine(selected?.find(el => el?.productId === data.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")), -(e.target.value), 'quantity');
                                            } else {
                                                changeHandlerLine(selected?.find(el => el?.productId === data.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")), e.target.value, 'quantity')
                                            }
                                        } else {
                                            changeHandlerLine(selected?.find(el => el?.productId === data.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")), e.target.value, 'quantity')
                                        }
                                    }}
                                    variant={'standard'}
                                    fullWidth
                                    value={selected?.find(el => el?.productId === data?.id && (el?.parentLineNumber == null || el?.parentLineNumber === ""))?.quantity}
                                />
                                <Image onClick={() => handleQuantityChange(selected?.find(el => el?.productId === data?.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")), salesType === 'Sales' ? 'decrease' : 'increase')} src={errorLineForm.productId === data.id ? SubtractButtonError : form?.productId === data?.id ? SubtractButtonSelected : SubtractButton} preview={false} />
                                <Image onClick={() => handleQuantityChange(selected?.find(el => el.productId === data?.id && (el?.parentLineNumber == null || el?.parentLineNumber === "")), salesType === 'Sales' ? 'increase' : 'decrease')} rootClassName={classes.addButon} src={errorLineForm.productId === data.id ? AddButonError : form?.productId === data?.id ? AddButonSelected : AddButon} preview={false} />
                            </div></>
                    }
                    <div className={clsx(classes.bold, classes.positionRelative)} style={{ background: `#FFFFFF`, boxShadow: `rgba(0, 0, 0, 0.25) 0px 3px 6px 0px` }}>{data?.salesUnit?.name}</div>
                </div>
            </div>
        )
    }

    return (
        <>
            <ProductGrid
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                loadMoreTask={() => loadMoreTask()}
                height={"100%"}
                classes={classes}
                {...props}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (<div style={{ marginTop: 50, width: "100%" }} className={classes.loadMoreCircle}></div>) : (
                                <Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <Fragment key={i}>
                                                {gridView(type === 'customerProducts' ? data?.product : data, type === 'customerProducts' ? data : [])}
                                            </Fragment>
                                        )) : <div style={{ width: "100%", marginTop: 40, textAlign: "center" }}>
                                            No Products Found
                                        </div>
                                    }
                                </Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}

